import React from 'react';
import { useBooking } from '../../hooks/useBooking';
import { useSiteColors } from '../../hooks/useSiteColors';

export function TrustBar() {
  const { businessListing } = useBooking();
  const c = useSiteColors();

  if (!businessListing?.trust_stats?.length) return null;

  const borderColor = c.border;

  return (
    <div
      className="py-8 overflow-x-auto"
      style={{ borderTop: `1px solid ${borderColor}`, borderBottom: `1px solid ${borderColor}` }}
    >
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="flex items-center justify-center gap-0">
          {businessListing.trust_stats.map((stat, i) => (
            <React.Fragment key={i}>
              {i > 0 && (
                <div
                  className="mx-8 h-10 w-px shrink-0"
                  style={{ backgroundColor: borderColor }}
                />
              )}
              <div className="text-center shrink-0">
                <div className="text-2xl sm:text-3xl font-bold" style={{ color: c.link }}>
                  {stat.value}
                </div>
                <div className="text-xs font-medium mt-1" style={{ color: c.mutedText }}>
                  {stat.label}
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
